import React from 'react';
import { Heading } from '@chakra-ui/react';
import { ResetPasswordForm } from './ResetPasswordForm';
import { FormWrapper } from 'components';
import { ReactComponent as UnlockedImage } from 'assets/unlocked.svg';
import { BasicLayout } from 'layouts';

const ResetPassword: React.FC = () => {
  return (
    <BasicLayout showLogo>
      <FormWrapper
        aboveForm={
          <Heading as="h1" pt={[0, 8]} size="lg" textAlign="center">
            Reset Password
          </Heading>
        }
        form={<ResetPasswordForm />}
        formImage={<UnlockedImage height="100%" />}
      />
    </BasicLayout>
  );
};

export default ResetPassword;
